module.exports = __webpack_public_path__ + "img/2.dac6d5ad.png";